
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from '../components/User/Login';
import Signup from '../components/User/Signup';
import OTPVerification from '../components/User/OTPVerification';
import SetNewPassword from '../components/User/SetNewPassword';
import ResetPassword from '../components/User/ResetPassword';
import WarehouseOnboarding from '../pages/Onboarding/WarehouseOnboarding';
import Dashboard from '../pages/Dashboard/Dashboard';
import InventorySettings from '../pages/Settings/InventorySettings';
import WarehouseSettings from '../pages/Settings/WarehouseSettings';
import FloorsPage from '../pages/Settings/FloorsPage';
import RoomsPage from '../pages/Settings/RoomsPage';
import RacksPage from '../pages/Settings/RacksPage';
import BinsPage from '../pages/Settings/BinsPage';
import Orders from '../pages/Orders/Orders';
import Delivery from '../pages/Delivery/Delivery';
import Items from '../pages/Inventory/Items';
import Transfers from '../pages/Inventory/Transfers';
import ItemFormPage from '../components/Inventory/ItemFormPage';
import ItemDetailsView from '../components/Inventory/ItemDetailsView';
import TransferDetailsView from '../components/Inventory/TransferDetailsView';
import Departments from '../pages/UserManagement/Departments';
import Roles from '../pages/UserManagement/Roles';
import Users from '../pages/UserManagement/Users';
import Organization from '../pages/Organization/Organization';
import NavigationBar from '../components/NavigationBar';
import MyProfile from '../pages/Profile/MyProfile';
import TrackOrder from '../pages/Track/TrackOrder';
import TrackSearch from '../pages/Track/TrackSearch';
import OrderPublicPage from '../pages/Orders/OrderPublicPage';

export default function AppRoutes() {
  return (
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/otp-verification" element={<OTPVerification />} />
        <Route path="/set-new-password" element={<SetNewPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/onboarding" element={<WarehouseOnboarding />} />
        <Route path="/track/:packageId" element={<TrackOrder />} />
        <Route path="/track/order/:orderId" element={<TrackOrder />} />
        <Route path="/track" element={<TrackSearch />} />
        <Route path="/orders/public" element={<OrderPublicPage />} />
        <Route path="/" element={<NavigationBar />}>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="orders" element={<Orders />} />
          <Route path="delivery" element={<Delivery />} />
          <Route path="inventory/items" element={<Items />} />
          <Route path="inventory/transfers" element={<Transfers />} />
          <Route path="inventory/items/new" element={<ItemFormPage />} />
          <Route path="inventory/items/edit" element={<ItemFormPage />} />
          <Route path="inventory/items/view" element={<ItemDetailsView />} />
          <Route path="inventory/transfers/view" element={<TransferDetailsView />} />
          <Route path="settings/warehouse" element={<WarehouseSettings />} />
          <Route path="settings/warehouse/buildings/:buildingId/floors" element={<FloorsPage />} />
          <Route path="settings/warehouse/buildings/:buildingId/floors/:floorId/rooms" element={<RoomsPage />} />
          <Route path="settings/warehouse/buildings/:buildingId/floors/:floorId/rooms/:roomId/racks" element={<RacksPage />} />
          <Route path="settings/warehouse/buildings/:buildingId/floors/:floorId/rooms/:roomId/racks/:rackId/bins" element={<BinsPage />} />
          <Route path="settings/inventory" element={<InventorySettings />} />
          <Route path="users/departments" element={<Departments />} />
          <Route path="users/roles" element={<Roles />} />
          <Route path="users/user" element={<Users />} />
          <Route path="organization" element={<Organization/>} />
          <Route path="profile" element={<MyProfile/>} />
        </Route>
      </Routes>
  );
};

